export const formatPathnameToSchoolSlug = (pathname: string, childPath?: string): string => {
  // slug EXCLUDES leading slash
  let slug = pathname.startsWith('/') ? pathname.slice(1) : pathname;

  // slug EXCLUDES childPath
  if (childPath) {
    slug = slug
      .split('/')
      .filter((seg) => seg !== childPath)
      .join('/');
  }

  // slug INCLUDES trailing slash
  return slug.endsWith('/') ? slug : `${slug}/`;
};

export const formatChildPath = (childPath?: string): string => {
  if (childPath) return `/${childPath}/`;
  return '/';
};
